import KathleenStern from '../../assets/images/kathleen_stern.jpg';
import '../../assets/scss/containers.scss';

const Overview = () => {
  return (
    <div className="fiterr-app-section">
      <div className="fiterr-app-inner-wrapper">
        <div className="fiterr-app-page-container">
          <div className="dashboard-welcome-wrapper">
            <div className="dashboard-welcome-image">
              <img src={KathleenStern} alt=""></img>
            </div>
            <div className="dashboard-welcome-message">
              Hi Kathleen, welcome to your Nutrition Overview! 😍 
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Overview;